<template>
    <div class="flex items-center mb-10">
        <FoundationHeadline tag="h3" class="h3 font-bold uppercase">{{ $t('layout.footerTopBar.followUs') }}</FoundationHeadline>
        <div class="flex">
            <a
                href="https://www.facebook.com/PrangeSchuhe"
                target="_blank"
                rel="noopener"
                :aria-label="$t('layout.footerTopBar.visitUnsOnFacebook')">
                <FoundationIcon name="facebook" class="block w-7 h-7 ms-5 overflow-hidden rounded-sm" />
            </a>
            <a
                href="https://www.instagram.com/prange_schuhe/"
                target="_blank"
                rel="noopener"
                :aria-label="$t('layout.footerTopBar.visitUnsOnInstagram')">
                <FoundationIcon name="instagram" class="block w-7 h-7  ms-5" />
            </a>
        </div>
    </div>
</template>
<script setup lang="ts">
</script>
